import { AfterViewInit, Directive, Host, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FilterService } from '@app/core/services/container/filter.service';
import { FilterItem, FilterOutput, FiltersOutput } from '@app/shared/models/filter.interface';
import { Subject, Subscription } from 'rxjs';
import { DataTableNewComponent } from '../data-table-new.component';
import { DataTableState } from '../state/state.model';
import { StateService } from '../state/state.service';

@Directive({ selector: '[vfsDatatableFilter]', exportAs: 'vfsDatatableFilter' })
export class DatatableFilterDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() panelFilters: FilterItem[] = [];

  stateId: string;
  stateChangeSubject$: Subject<DataTableState>;

  filterButtonSubscription: Subscription;

  constructor(
    @Host() private parent: DataTableNewComponent<any>,
    @Inject('StateService') private stateService: StateService,
    private filterService: FilterService
  ) {}

  ngOnInit() {
    this.stateId = this.parent.stateId;
    this.stateChangeSubject$ = this.parent.stateChangeSubject$;
    this.parent.withFilters = true;
  }

  ngAfterViewInit() {
    const currentState: DataTableState = this.stateService.get(this.stateId);
    currentState.page.index = 0;

    // init data
    this.getFilterValues(currentState);

    this.filterButtonSubscription = this.parent.filtersButton.buttonClick.subscribe(_ => {
      this.stateId = this.parent.stateId;
      const currentState: DataTableState = this.stateService.get(this.stateId);
      // init popup data
      this.getFilterValues(currentState);

      this.filterService.openWithData(this.panelFilters).subscribe((filtersOutput: FiltersOutput) => {
        if (!filtersOutput.accept) {
          return;
        }
        this.parent.areFiltersApplied = false;

        filtersOutput.filters.forEach((f: FilterOutput) => {
          currentState.filter.value[f.key] = f;
          this.hasFilterActive(f);
        });

        this.stateService.update(currentState);

        this.stateChangeSubject$.next(currentState);
      });
    });
  }

  getFilterValues(currentState: DataTableState) {
    this.parent.areFiltersApplied = false;
    this.panelFilters.forEach((item: FilterItem) => {
      if (currentState.filter.value[item.field.formControlName]) {
        item.value = currentState.filter.value[item.field.formControlName].value;
        this.hasFilterActive(item);
      }
    });
  }

  hasFilterActive(filter) {
    if (filter.value && Object.keys(filter.value).length != 0) {
      this.parent.areFiltersApplied = true;
    }
  }

  ngOnDestroy() {
    if (this.filterButtonSubscription) {
      this.filterButtonSubscription.unsubscribe();
    }
  }
}
